import provideState_MaX9fQr3GV from "/app/node_modules/nuxt-graphql-middleware/dist/runtime/plugins/provideState.js";
import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_4F1kZh3YAB from "/app/node_modules/nuxt-viewport/dist/runtime/plugin.client.js";
import language_Zy8KLHw9oT from "/app/node_modules/nuxt-language-negotiation/dist/runtime/plugins/language.mjs";
import plugin_HVXxfS1SwW from "/app/node_modules/nuxt-multi-tenancy/dist/runtime/plugin.mjs";
import blokkliEditable_4phZLIxAsp from "/app/node_modules/@blokkli/editor/dist/runtime/plugins/blokkliEditable.js";
import clickaway_ZmIhydr7La from "/app/plugins/clickaway.ts";
import graphqlMiddleware_2xI7SMabjg from "/app/plugins/graphqlMiddleware.ts";
import texts_P4dMAr3Ct0 from "/app/node_modules/nuxt-easy-texts/dist/runtime/plugins/texts.mjs";
import drupalUser_HxAWH89yLt from "/app/plugins/drupalUser.ts";
import inlineHtml_5z3VjJToyQ from "/app/plugins/inlineHtml.ts";
import tracking_RJtqiU4YuV from "/app/plugins/tracking.ts";
export default [
  provideState_MaX9fQr3GV,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_4F1kZh3YAB,
  language_Zy8KLHw9oT,
  plugin_HVXxfS1SwW,
  blokkliEditable_4phZLIxAsp,
  clickaway_ZmIhydr7La,
  graphqlMiddleware_2xI7SMabjg,
  texts_P4dMAr3Ct0,
  drupalUser_HxAWH89yLt,
  inlineHtml_5z3VjJToyQ,
  tracking_RJtqiU4YuV
]